import Resource, { createResourceHook } from '@tabeo/resync'
import api from '@tabeo/sharpei/utils/api'
import { Bill } from '@tabeo/ts-types'
import normalize from './normalizers/bill'

interface Data {
  items: null | Bill[]
  totalCount: number
}

interface Params {
  activeTabs: { statuses: string[] }[]
  searchQuery: string
  limit: number
  offset: number
  orderBy: { field: string; direction: string }
}

class Bills extends Resource<Data, Params> {
  getInitialData() {
    return {
      items: null,
      totalCount: 0,
    }
  }

  getInitialConfig() {
    return {
      refreshInterval: 15 * 1000,
    }
  }

  async fetch(query: string) {
    const {
      activeTabs = [],
      searchQuery = query,
      limit = 10,
      offset = 0,
      orderBy: { field, direction } = { field: 'id', direction: 'desc' },
    } = this.params

    const statuses = activeTabs.reduce((mem, tab) => {
      mem = [...mem, ...tab.statuses]
      return mem
    }, [] as string[])

    const order = `&order=${field}:${direction}`
    const condition = `&condition=status:[${statuses.join(',')}]`
    const pagination = `&limit=${limit}&offset=${offset}`
    const endpoint = searchQuery
      ? `/bill-search?${order}&searchPhrase=${encodeURIComponent(searchQuery)}`
      : `/bills?${order}`

    const {
      data: { bills },
      totalCount,
    } = await api.get(
      `${endpoint}${condition}${pagination}&subResource=merchant`,
      {
        responseDataPath: 'data',
      }
    )

    const normalizedBills = bills.map((o: Bill) => normalize(o))

    const data = {
      totalCount,
      items: normalizedBills,
    }

    this.data = data

    return data
  }
}

export default Bills
export const useBills = createResourceHook(Bills)
